import { render, staticRenderFns } from "./attestation.vue?vue&type=template&id=ef07106c&scoped=true&"
import script from "./attestation.vue?vue&type=script&lang=js&"
export * from "./attestation.vue?vue&type=script&lang=js&"
import style0 from "./attestation.vue?vue&type=style&index=0&id=ef07106c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef07106c",
  null
  
)

export default component.exports